module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meta-management"
  }, [_c('h1', [_vm._v("资料管理")]), _c('div', {
    staticClass: "sections"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("房间备注标签")]), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 30
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  }), _c('br'), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTags
    }
  }, [_vm._v("保存")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2a129ce","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Admin/MetaManagement.vue
// module id = 473
// module chunks = 0